import React, { useState } from "react";
import api from "../services/api";
import toast from "react-hot-toast";

export default function Import() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async e => {
    e.preventDefault();
    if (!file) return toast.error("Sélectionnez un fichier Excel");
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post("/import/excel", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setResult(r.data);
      toast.success(r.data.message);
    } catch(e) { toast.error(e.response?.data?.error || "Erreur import"); }
    setLoading(false);
  };

  return (
    <div style={{ padding: 32, maxWidth: 700, margin: "0 auto" }}>
      <h1 style={{ fontSize: 24, fontWeight: 800, color: "#1B3A8C", marginBottom: 8 }}>Import Excel</h1>
      <p style={{ color: "#888", marginBottom: 32 }}>Importez un fichier Excel pour créer automatiquement des supports et un formulaire</p>

      <div style={{ background: "#fff", borderRadius: 16, padding: 32, boxShadow: "0 2px 12px rgba(0,0,0,0.08)", marginBottom: 24 }}>
        <h3 style={{ color: "#1B3A8C", marginBottom: 16 }}>📋 Colonnes reconnues automatiquement</h3>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 20 }}>
          {[["nom / libelle / designation","Nom du support"],["code / reference / ref","Code unique"],["description","Description"],["localisation / lieu / bureau","Localisation"],["adresse","Adresse"],["proprietaire / responsable","Propriétaire"],["valeur / prix / montant","Valeur (GNF)"],["statut / etat","Statut"],["latitude / lat","Latitude GPS"],["longitude / lon","Longitude GPS"]].map(([k,v]) => (
            <div key={k} style={{ background: "#f8f9fa", borderRadius: 8, padding: "8px 12px" }}>
              <div style={{ fontSize: 11, color: "#F5A800", fontWeight: 700 }}>{k}</div>
              <div style={{ fontSize: 12, color: "#555" }}>{v}</div>
            </div>
          ))}
        </div>
        <div style={{ background: "#e8f4fd", borderRadius: 8, padding: 12, fontSize: 13, color: "#1B3A8C" }}>
          💡 Les autres colonnes seront conservées dans les données supplémentaires du support et utilisées pour créer le formulaire.
        </div>
      </div>

      <div style={{ background: "#fff", borderRadius: 16, padding: 32, boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }}>
        <form onSubmit={submit}>
          <div style={{ border: "2px dashed #1B3A8C", borderRadius: 12, padding: 40, textAlign: "center", marginBottom: 24, cursor: "pointer" }}
            onClick={() => document.getElementById("fileInput").click()}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>📊</div>
            <div style={{ fontWeight: 700, color: "#1B3A8C", fontSize: 16 }}>
              {file ? file.name : "Cliquer pour sélectionner un fichier Excel"}
            </div>
            <div style={{ fontSize: 13, color: "#888", marginTop: 4 }}>Formats acceptés: .xlsx, .xls, .csv</div>
            <input id="fileInput" type="file" accept=".xlsx,.xls,.csv" style={{ display: "none" }}
              onChange={e => setFile(e.target.files[0])} />
          </div>
          <button type="submit" disabled={loading || !file} style={{
            width: "100%", padding: 14, background: loading || !file ? "#ccc" : "#1B3A8C",
            color: "#fff", border: "none", borderRadius: 8, fontWeight: 700, cursor: loading || !file ? "not-allowed" : "pointer", fontSize: 15
          }}>
            {loading ? "⏳ Import en cours..." : "📥 Importer et créer les supports"}
          </button>
        </form>
      </div>

      {result && (
        <div style={{ background: "#fff", borderRadius: 16, padding: 32, boxShadow: "0 2px 12px rgba(0,0,0,0.08)", marginTop: 24 }}>
          <h3 style={{ color: "#28a745", marginBottom: 16 }}>✅ Import terminé</h3>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
            <div style={{ background: "#f0fff4", borderRadius: 10, padding: 16, textAlign: "center" }}>
              <div style={{ fontSize: 32, fontWeight: 800, color: "#28a745" }}>{result.supportsCreees}</div>
              <div style={{ fontSize: 13, color: "#555" }}>Supports créés</div>
            </div>
            <div style={{ background: "#e8f4fd", borderRadius: 10, padding: 16, textAlign: "center" }}>
              <div style={{ fontSize: 20, fontWeight: 700, color: "#1B3A8C" }}>📋</div>
              <div style={{ fontSize: 13, color: "#555" }}>Formulaire: {result.formulaireTitre}</div>
            </div>
          </div>
          {result.erreurs?.length > 0 && (
            <div style={{ background: "#fff3f3", borderRadius: 8, padding: 12 }}>
              <div style={{ color: "#dc3545", fontWeight: 700, marginBottom: 8 }}>⚠️ {result.erreurs.length} erreur(s)</div>
              {result.erreurs.map((e,i) => <div key={i} style={{ fontSize: 12, color: "#666" }}>Ligne {e.ligne}: {e.erreur}</div>)}
            </div>
          )}
          <div style={{ display: "flex", gap: 12, marginTop: 16 }}>
            <a href="/supports" style={{ flex:1, padding:10, background:"#1B3A8C", color:"#fff", borderRadius:8, textAlign:"center", textDecoration:"none", fontWeight:700, fontSize:13 }}>📦 Voir les supports</a>
            <a href="/formulaires" style={{ flex:1, padding:10, background:"#F5A800", color:"#fff", borderRadius:8, textAlign:"center", textDecoration:"none", fontWeight:700, fontSize:13 }}>📋 Voir les formulaires</a>
          </div>
        </div>
      )}
    </div>
  );
}
